import '../App.css';

function Question() {
    return (
        <div className="question">
            <h1>PL Vote</h1>
            <h3>What is your favorite PL?</h3>
        </div>
    )
}

export default Question;